import { PDFDocument } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit';

import fechaActual from '../datos/fechaActual';
import formatearFecha from "../../helpers/datos/formatearFecha";

import { obtenerNombreMunicipio } from '../catalogos/metodos/obtenerNombreMunicipio';
import { obtenerNombreLocalidad } from '../catalogos/metodos/obtenerNombreLocalidad';
import { obtenerNombreArea } from '../usuario/obtenerNombreArea';
import formatearNumero from '../datos/formatearNumero';
import mensajeError from '../mensajes/MensajeError';

import formatearDatosAdicionales from "../datos/formatearDatosAdicionales";
/**
 * Genera un nuevo PDF para una nueva poliza generada
 * @param {Object} concesionActual 
 */
const rellenarPDF = async (data, nuevosTramites, aPagar, vigencia, lineaCaptura, folio, observaciones, anualidad) => {
    const concesionActual = data.concesionActual;
    const contribuyente = data.contribuyente;
    const direccion = data.direcciones[0] ?? [];
    var d = new Date();
    var n = d.toLocaleTimeString();

    var datosAdicionales = `AUTORIZACIÓN: ${concesionActual.idConcesion ?? ""}; EXPEDIENTE: ${concesionActual.numeroExpediente ?? ""}; PLACAS: ${concesionActual.seriePlaca ?? ""}; OBSERVACIONES: ${observaciones}; ANUALIDAD: ${anualidad ?? ""};`;

    try {
        const { name, lastName, surname } = JSON.parse(localStorage.getItem("usuario"));
        const formUrl = "/plantila_orden_pago_formulario.pdf";
        const formPdfBytes = await fetch(formUrl).then(res => res.arrayBuffer());

        const fontUrl = "/ConnectCode39.ttf";
        const fontBytes = await fetch(fontUrl).then(res => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(formPdfBytes);
        pdfDoc.registerFontkit(fontkit);

        const customFont = await pdfDoc.embedFont(fontBytes);
        const form = pdfDoc.getForm();

        const barcodeField = form.getTextField("codigoBarras_")
        barcodeField.setFontSize(12);
        barcodeField.setText("*" + lineaCaptura + "*" ?? "");
        barcodeField.updateAppearances(customFont);
        const referenciaBancaria = form.getTextField("referenciaBancaria_")
        referenciaBancaria.setText(lineaCaptura ?? "")
        referenciaBancaria.setFontSize(7);
        form.getTextField("folio_").setText(String(folio) ?? "");

        const rfcField = form.getTextField('RFC_');
        const curpField = form.getTextField("CURP_");
        const cpField = form.getTextField("CP_");
        const nombreField = form.getTextField("nombre_");

        rfcField.setText(contribuyente.rfc ?? "");
        rfcField.setFontSize(7);
        curpField.setText(contribuyente.curp ?? "");
        curpField.setFontSize(7);
        cpField.setText(direccion?.codigoPostal ?? "");
        cpField.setFontSize(7);
        nombreField.setText(`${contribuyente.apellidoPaterno} ${contribuyente.apellidoMaterno} ${contribuyente.nombre}`);
        nombreField.setFontSize(7);

        const calleField = form.getTextField("calle_");
        const noExteriorField = form.getTextField("noExterior_");
        const noInteriorField = form.getTextField("noInterior_");
        const telefonoField = form.getTextField("telefono_");

        calleField.setText(direccion?.calle ?? "");
        calleField.setFontSize(7);
        noExteriorField.setText(direccion?.numeroExterior ?? "");
        noExteriorField.setFontSize(7);
        noInteriorField.setText(direccion?.numeroInterior ?? "");
        noInteriorField.setFontSize(7);
        telefonoField.setText(direccion?.telefono ?? "");
        telefonoField.setFontSize(7);

        const coloniaField = form.getTextField("colonia_");
        const localidadField = form.getTextField("localidad_");
        const municipioField = form.getTextField("municipio_");

        coloniaField.setText(direccion?.colonia ?? "");
        coloniaField.setFontSize(7);
        localidadField.setText(await obtenerNombreLocalidad(direccion?.idLocalidad) ?? "");
        localidadField.setFontSize(7);
        municipioField.setText(await obtenerNombreMunicipio(direccion?.idMunicipio) ?? "");
        municipioField.setFontSize(7);

        const areaField = form.getTextField("area_");
        const datosAdicionalesField = form.getTextField("observaciones_");
        datosAdicionalesField.setText(formatearDatosAdicionales(datosAdicionales).toUpperCase());
        datosAdicionalesField.setFontSize(7);
        areaField.enableMultiline();
        areaField.setText(`${await obtenerNombreArea(1)} - DIRECCIÓN DE REGISTRO`);
        areaField.setFontSize(6);


        for (let i = 0; i < nuevosTramites.length; i++) {
            var criField = form.getTextField(`CRI_${i + 1}`);
            let descField = form.getTextField(`descripcion_${i + 1}`);
            let importeField = form.getTextField(`importe_${i + 1}`);
            criField.setText(String(nuevosTramites[i].cri) ?? "");
            criField.setFontSize(7);
            descField.setText(nuevosTramites[i].concepto.toUpperCase() ?? "");
            importeField.setText(`$${formatearNumero(nuevosTramites[i].pagoFinal)}`);

            criField.setFontSize(7);
            descField.setFontSize(6);
            importeField.setFontSize(7);
        }

        const fechaLimiteField = form.getTextField("fechaLimite_");
        fechaLimiteField.setText(formatearFecha(vigencia).toUpperCase());
        fechaLimiteField.setFontSize(7);
        const importFinal = form.getTextField("total_");
        importFinal.setText(`$${formatearNumero(aPagar)}`);
        importFinal.setFontSize(7);
        form.getTextField("usuario_").setText(`${name} ${lastName} ${surname}`.toUpperCase());

        form.getTextField("fecha_").setText(fechaActual().toUpperCase() + " "+ n);

        form.flatten();

        // Guardar el archivo PDF llenado
        const pdfBytes = await pdfDoc.save();

        // Puedes descargar el PDF llenado utilizando un objeto Blob
        const blob = new Blob([pdfBytes], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Orden de pago.pdf";
        link.click();
    }
    catch (error) {
        mensajeError("No pudo generarse el PDF");
    }
}

export default rellenarPDF;